import React, { type FunctionComponent } from 'react'
import { Button } from '@retailer-platform/shared-components'
import { PageHeader } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { type CollectionsRoutingConfig } from 'domains/collections/types/collections.types'
import { CollectionsBreadcrumbs } from 'domains/collections/components/breadcrumbs/CollectionsBreadcrumbs'
import { useDomainGoToPath } from 'domains/collections/utils/domain/routing'

interface CollectionsListHeaderProps {
  routingConfig: CollectionsRoutingConfig
}

export const CollectionsListHeader: FunctionComponent<CollectionsListHeaderProps> = ({
  routingConfig,
}) => {
  const goToNewCollection = useDomainGoToPath(routingConfig.new)
  const newCollection = useDomainMessage('collectionsDomain.new.title')

  return (
    <PageHeader
      addBottomPadding
      title={<CollectionsBreadcrumbs routingConfig={routingConfig} />}
      actions={<Button onClick={goToNewCollection}>{newCollection}</Button>}
    />
  )
}
